import { Reducer } from 'redux';

import { ActionType } from '../../../../store/actionTypes';
import {
  ActionWithPlayload,
  EntityAction,
  ErrorAction,
} from '../../../../store/types';

export interface CollectionState {
  items: string[];
  isFetching: boolean;
  error?: string | null;
}

export const initialState: CollectionState = {
  items: [],
  isFetching: false,
  error: null,
};

export interface FetchActionTypes<
  ST extends ActionType,
  SU extends ActionType,
  FA extends ActionType,
> {
  started: ST;
  succeeded: SU;
  failed: FA;
}

export type FetchAction<
  ST extends ActionType,
  SU extends ActionType,
  FA extends ActionType,
> = ActionWithPlayload<ST> | EntityAction<SU> | ErrorAction<FA>;

export function createCollectionReducer<
  ST extends ActionType,
  SU extends ActionType,
  FA extends ActionType,
>(
  actionTypes: FetchActionTypes<ST, SU, FA>,
): Reducer<CollectionState, FetchAction<ST, SU, FA>> {
  return function (
    state: CollectionState = initialState,
    action: FetchAction<ST, SU, FA>,
  ): CollectionState {
    switch (action.type) {
      case actionTypes.started:
        return {
          ...state,
          isFetching: true,
        };

      case actionTypes.succeeded:
        return {
          ...state,
          isFetching: false,
          items: action.payload.result as string[],
        };

      case actionTypes.failed:
        return {
          ...state,
          isFetching: false,
          error: action.payload.message,
        };

      default:
        return state;
    }
  };
}
